import { render, staticRenderFns } from "./DraggableNode.vue?vue&type=template&id=313182d6&"
import script from "./DraggableNode.vue?vue&type=script&lang=js&"
export * from "./DraggableNode.vue?vue&type=script&lang=js&"
import style0 from "./DraggableNode.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports